import { COMMON_SERVICE, DEALER_SERVICE } from '../pageLoad/constants';

export const pageLoadInitialStore = {
  /**
   * COMMON AND DEALER are registered here to avoid racing condition in usePopulateDataLayer
   */
  serviceCallsPendingToResolve: [COMMON_SERVICE, DEALER_SERVICE]
};
